export default class projects {
  constructor() {
    this.changeProject();
    this.changeEdition();
    this.scrollToContent();
    this.scrollToSection();
    this.pinMenu();
  }

  changeProject() {
    const $projectsSlider = $('.projects-slider__slides');
    $projectsSlider.find('.nav-link[data-toggle="tab"]').on('click', (e) => {
      $projectsSlider.find('.nav-link[data-toggle="tab"]').not(e.target).removeClass('active show').attr('aria-selected', 'false');

      const projectId = $(e.target).data('project-id');

      // Projects slider
      // --------------------------------------------
      // --------------------------------------------

      // Remove slick-current classes from all slides
      $projectsSlider.find('.slick-slide').removeClass('slick-current');

      // Add slick-current class for current slide
      const $slickSlide = $(e.target).closest('.slick-slide');
      ($slickSlide.hasClass('slick-current')) ? $slickSlide.removeClass('slick-current') : $slickSlide.addClass('slick-current');


      // Editions slider
      // --------------------------------------------
      // --------------------------------------------

      // Remove active classes from all slides
      const $editionsSlider = $('.editions-slider__single');
      $editionsSlider.find('.slick-slide').removeClass('active');

      // Set first edition block as active after change of project tab
      const $editionSlide = $editionsSlider.find('.block:first-child');
      ($editionSlide.hasClass('active')) ? $editionSlide.removeClass('active') : $editionSlide.addClass('active');

      // Set first menu as active after change of project tab
      const $allMenuWrappers = $('.projects__main__content__menu .all-menus .wrapper');
      $allMenuWrappers.find('.menu').removeClass('active');
      $allMenuWrappers.find('.menu:first-child').addClass('active');


      // Show specific content and menu for
      // current project
      // --------------------------------------------
      // --------------------------------------------

      const $projectBlocks = $('.projects__main__content__wrapper');
      const $projectMenus = $('.projects__main__content__menu .all-menus');

      // Remove active classes from all project blocks
      $projectBlocks.find('.project-block').removeClass('active');

      // Add active class for current project block
      const $specificBlock = $projectBlocks.find('.project-block[data-project-id="' + projectId + '"]');
      ($specificBlock.hasClass('active')) ? $specificBlock.removeClass('active') : $specificBlock.addClass('active');

      // Remove active classes from all project menus
      $projectMenus.find('.wrapper').removeClass('active');

      // Add active class for current project menu
      const $specificMenu = $projectMenus.find('.wrapper[data-project-id="' + projectId + '"]');
      ($specificMenu.hasClass('active')) ? $specificMenu.removeClass('active') : $specificMenu.addClass('active');


      // Update breadcrumbs
      // --------------------------------------------
      // --------------------------------------------

      const $breadcrumbs = $('.projects__main__content__menu .breadcrumbs');
      const $editionLogo = $breadcrumbs.find('.edition-logo img');
      const editionLogoSrc = $(e.target).data('project-logo');

      $editionLogo.attr('src', editionLogoSrc);
    });
  }

  changeEdition() {
    const $editionsSlider = $('.editions-slider__single');
    $editionsSlider.find('.block').on('click', (e) => {
      // Change active tab
      // --------------------------------------------
      // --------------------------------------------

      // Remove active classes from all slides
      $editionsSlider.find('.slick-slide').removeClass('active');

      // Add slick-current class for current slide
      const $slickSlide = $(e.target).closest('.slick-slide');
      const projectId = $slickSlide.data('project-id');
      const editionId = $slickSlide.data('edition-id');
      ($slickSlide.hasClass('active')) ? $slickSlide.removeClass('active') : $slickSlide.addClass('active');


      // Show specific content and menu for
      // current project
      // --------------------------------------------
      // --------------------------------------------
      const $projectBlocks = $('.projects__main__content__wrapper');
      const $projectMenus = $('.projects__main__content__menu .all-menus');

      // Remove active classes from all wrapper in current project block
      $projectBlocks.find('.project-block[data-project-id="' + projectId + '"] .wrapper').removeClass('active');

      // Add active class for wrapper in current project blocks
      const $wrapperBlock = $projectBlocks.find('.project-block[data-project-id="' + projectId + '"] .wrapper[data-edition-id="' + editionId + '"]');
      ($wrapperBlock.hasClass('active')) ? $wrapperBlock.removeClass('active') : $wrapperBlock.addClass('active');

      // Remove active classes from all menus in current project block
      $projectMenus.find('.wrapper[data-project-id="' + projectId + '"] .menu').removeClass('active');

      // Add active class for menu in current project blocks
      const $specificMenu = $projectMenus.find('.wrapper[data-project-id="' + projectId + '"] .menu[data-edition-id="' + editionId + '"]');
      ($specificMenu.hasClass('active')) ? $specificMenu.removeClass('active') : $specificMenu.addClass('active');


      // Update breadcrumbs
      // --------------------------------------------
      // --------------------------------------------

      const $breadcrumbs = $('.projects__main__content__menu .breadcrumbs');
      const $editionName = $breadcrumbs.find('.edition-name strong');
      const editionNameText = $(e.target).find('.block__content .title').text();

      $editionName.text(editionNameText);
    });
  }

  scrollToContent() {
    $('.projects__main__sliders .button-projects').on('click', (e) => {
      e.preventDefault();

      const $button = $(e.target).closest('.button-projects');

      const $menu = $('.projects__main__content__menu');
      const menuHeight = $menu.outerHeight();

      const $wpadminBar = $('#wpadminbar');
      let wpadminBarHeight;
      ($wpadminBar.length) ? wpadminBarHeight = $wpadminBar.outerHeight() : wpadminBarHeight = 0;

      $('html, body').animate({
        scrollTop: $('.projects__main__content__wrapper').offset().top - menuHeight - wpadminBarHeight,
      }, 600);
      $button.blur();
    });
  }

  scrollToSection() {
    $('.projects__main__content__menu .menu__item a').on('click', (e) => {
      e.preventDefault();

      const target = e.target.getAttribute('href').replace('#', '');
      const $section = $('#' + target);

      if (!$section) {
        return;
      }

      const $menu = $('.projects__main__content__menu');
      const menuHeight = $menu.outerHeight();

      const $wpadminBar = $('#wpadminbar');
      let wpadminBarHeight;
      ($wpadminBar.length) ? wpadminBarHeight = $wpadminBar.outerHeight() : wpadminBarHeight = 0;

      $('html, body').animate({
        scrollTop: $section.offset().top  - menuHeight - wpadminBarHeight,
      }, 800);

      location.hash = target;
    });
  }

  pinMenu() {
    const $menuNav = $('.projects__main__content__menu');
    if ($menuNav.length) {
      const $nextSection = $menuNav.siblings('.projects__main__content__wrapper');

      const $wpadminBar = $('#wpadminbar');
      let wpadminBarHeight;
      ($wpadminBar.length) ? wpadminBarHeight = $wpadminBar.outerHeight() : wpadminBarHeight = 0;

      let stop = ($menuNav.offset().top - wpadminBarHeight);

      window.addEventListener('scroll', () => {
        let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

        if (scrollTop >= stop) {
          if (!$menuNav.hasClass('sticky')) {
            $menuNav.addClass('sticky');
            $menuNav.css('top', wpadminBarHeight + 'px');
          }
          $nextSection.css('margin-top', $menuNav.outerHeight());
        } else {
          if ($menuNav.hasClass('sticky')) {
            $menuNav.removeClass('sticky');
            $menuNav.css('top', 'auto');
          }
          $nextSection.css('margin-top', 0);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/projects.js